export default __webpack_public_path__ + "static/media/aboutCat2XS.8e528c31.webp";